import buildCleanShortSlugFromCampaignKey from './buildCleanShortSlugFromCampaignKey'

export const buildShortSlug = ({ campaignKey }) => buildCleanShortSlugFromCampaignKey(campaignKey)

export const buildFinalUtmUrl = ({ destinationUrl, utmSource, utmMedium, utmCampaign, utmContent }) => {
  if (!destinationUrl) {
    return ''
  }

  try {
    const url = new URL(destinationUrl)
    url.searchParams.set('utm_source', utmSource)
    url.searchParams.set('utm_medium', utmMedium)
    url.searchParams.set('utm_campaign', utmCampaign)
    url.searchParams.set('utm_content', utmContent)
    return url.toString()
  } catch {
    return ''
  }
}
